/* ============================================================
   ES Naturals Theme — Main JavaScript
   ============================================================ */

document.addEventListener('DOMContentLoaded', function () {
  const header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', () => {
      header.classList.toggle('scrolled', window.scrollY > 40);
    }, { passive: true });
  }

  const mobileMenuBtn = document.querySelector('.mobile-menu-btn');
  const mobileNav = document.querySelector('.mobile-nav');
  const mobileNavOverlay = document.querySelector('.mobile-nav-overlay');
  const mobileNavClose = document.querySelector('.mobile-nav-close');

  function openMobileNav() {
    if (mobileNav) {
      mobileNav.classList.add('open');
      document.body.style.overflow = 'hidden';
    }
  }

  function closeMobileNav() {
    if (mobileNav) {
      mobileNav.classList.remove('open');
      document.body.style.overflow = '';
    }
  }

  if (mobileMenuBtn) mobileMenuBtn.addEventListener('click', openMobileNav);
  if (mobileNavOverlay) mobileNavOverlay.addEventListener('click', closeMobileNav);
  if (mobileNavClose) mobileNavClose.addEventListener('click', closeMobileNav);

  const cartDrawer = document.querySelector('.cart-drawer');
  const cartOverlay = document.querySelector('.cart-drawer-overlay');
  const cartBtns = document.querySelectorAll('[data-open-cart]');
  const cartClose = document.querySelector('.cart-drawer-close');
  let liveMessage = document.querySelector('[data-cart-live-message]');

  if (!liveMessage) {
    liveMessage = document.createElement('div');
    liveMessage.className = 'visually-hidden';
    liveMessage.setAttribute('aria-live', 'polite');
    liveMessage.setAttribute('data-cart-live-message', '');
    document.body.appendChild(liveMessage);
  }

  function announce(message) {
    liveMessage.textContent = '';
    window.setTimeout(() => { liveMessage.textContent = message; }, 30);
  }

  function openCart() {
    if (cartDrawer) {
      cartDrawer.classList.add('open');
      cartDrawer.setAttribute('aria-hidden', 'false');
    }
    if (cartOverlay) {
      cartOverlay.classList.add('open');
      cartOverlay.setAttribute('aria-hidden', 'false');
    }
    document.body.style.overflow = 'hidden';
  }

  function closeCart() {
    if (cartDrawer) {
      cartDrawer.classList.remove('open');
      cartDrawer.setAttribute('aria-hidden', 'true');
    }
    if (cartOverlay) {
      cartOverlay.classList.remove('open');
      cartOverlay.setAttribute('aria-hidden', 'true');
    }
    document.body.style.overflow = '';
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>'"]/g, character => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      "'": '&#039;',
      '"': '&quot;'
    }[character]));
  }

  function formatMoney(cents) {
    return '$' + (Number(cents) / 100).toFixed(2);
  }

  async function getCart() {
    const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Unable to load cart');
    return response.json();
  }

  function updateCartCount(cart) {
    document.querySelectorAll('.cart-count').forEach(element => {
      element.textContent = cart.item_count;
      element.style.display = cart.item_count > 0 ? 'flex' : 'none';
    });
  }

  async function changeQuantity(key, quantity) {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    });

    if (!response.ok) throw new Error('Unable to update cart');
    const cart = await response.json();
    updateCartCount(cart);
    await renderCartItems(cart);
    announce(quantity === 0 ? 'Item removed from your cart.' : 'Cart quantity updated.');
  }

  async function renderCartItems(cart) {
    const activeCart = cart || await getCart();
    const body = document.querySelector('.cart-drawer-body');
    const footer = document.querySelector('.cart-drawer-footer');
    if (!body) return activeCart;

    if (activeCart.item_count === 0) {
      body.innerHTML = `
        <div class="cart-empty">
          <p>Your cart is empty.</p>
          <a href="/collections/all" class="btn btn-primary" id="cart-empty-shop-btn">Shop Now</a>
        </div>`;
      if (footer) footer.innerHTML = '';
      return activeCart;
    }

    body.innerHTML = activeCart.items.map(item => `
      <div class="cart-item">
        <div class="cart-item-image">
          ${item.image ? `<img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.product_title)}" loading="lazy">` : ''}
        </div>
        <div class="cart-item-details">
          <div class="cart-item-title">${escapeHtml(item.product_title)}</div>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="cart-item-variant">${escapeHtml(item.variant_title)}</div>` : ''}
          <div class="cart-item-price">${formatMoney(item.final_price)}</div>
          <div class="cart-item-qty" aria-label="Quantity for ${escapeHtml(item.product_title)}">
            <button class="qty-btn" type="button" data-change-qty="${escapeHtml(item.key)}" data-delta="-1" aria-label="Decrease quantity">−</button>
            <span class="qty-num" aria-live="polite">${item.quantity}</span>
            <button class="qty-btn" type="button" data-change-qty="${escapeHtml(item.key)}" data-delta="1" aria-label="Increase quantity">+</button>
          </div>
        </div>
      </div>`).join('');

    if (footer) {
      footer.innerHTML = `
        <div class="cart-subtotal"><span>Subtotal</span><span>${formatMoney(activeCart.total_price)}</span></div>
        <p class="cart-shipping-note">Free shipping on orders over $50. Shipping and taxes are calculated at checkout.</p>
        <a href="/checkout" class="cart-checkout-btn">Checkout →</a>`;
    }

    body.querySelectorAll('[data-change-qty]').forEach(button => {
      button.addEventListener('click', async () => {
        const key = button.dataset.changeQty;
        const currentItem = activeCart.items.find(item => item.key === key);
        if (!currentItem) return;
        const newQuantity = Math.max(0, currentItem.quantity + Number(button.dataset.delta));
        button.disabled = true;
        try {
          await changeQuantity(key, newQuantity);
        } catch (error) {
          console.error('Cart quantity update error:', error);
          announce('We could not update your cart. Please try again.');
        } finally {
          button.disabled = false;
        }
      });
    });

    return activeCart;
  }

  async function refreshAndOpenCart() {
    try {
      const cart = await getCart();
      updateCartCount(cart);
      await renderCartItems(cart);
      openCart();
    } catch (error) {
      console.error('Cart refresh error:', error);
      openCart();
      announce('Your cart could not be refreshed. Please open the cart page to review it.');
    }
  }

  async function addItem(variantId, quantity) {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
    });

    if (!response.ok) {
      let errorMessage = 'We could not add this item to your cart.';
      try {
        const data = await response.json();
        if (data.description) errorMessage = data.description;
      } catch (error) {
        console.error('Cart add response error:', error);
      }
      throw new Error(errorMessage);
    }

    const cart = await getCart();
    updateCartCount(cart);
    await renderCartItems(cart);
    openCart();
    announce('Added to your cart.');
    return cart;
  }

  cartBtns.forEach(button => button.addEventListener('click', refreshAndOpenCart));
  if (cartClose) cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  document.querySelectorAll('[data-add-to-cart]').forEach(button => {
    button.addEventListener('click', async function () {
      const variantId = this.dataset.variantId;
      if (!variantId) return;

      const originalText = this.textContent;
      this.textContent = 'Adding…';
      this.disabled = true;

      try {
        await addItem(variantId, 1);
      } catch (error) {
        console.error('Add to cart error:', error);
        announce(error.message || 'We could not add this item to your cart.');
      } finally {
        this.textContent = originalText;
        this.disabled = false;
      }
    });
  });

  window.ESNaturalsCart = {
    addItem,
    open: refreshAndOpenCart,
    refresh: async () => {
      const cart = await getCart();
      updateCartCount(cart);
      await renderCartItems(cart);
      return cart;
    }
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.08, rootMargin: '0px 0px -30px 0px' });

  document.querySelectorAll('.fade-up').forEach(element => observer.observe(element));

  document.querySelectorAll('.filter-tab').forEach(tab => {
    tab.addEventListener('click', () => {
      document.querySelectorAll('.filter-tab').forEach(item => item.classList.remove('active'));
      tab.classList.add('active');
      const filter = tab.dataset.filter;
      document.querySelectorAll('.product-card').forEach(card => {
        const categories = (card.dataset.category || '').toLowerCase();
        card.style.display = filter === 'all' || categories.includes(filter) ? '' : 'none';
      });
    });
  });

  document.addEventListener('click', event => {
    if (event.target && event.target.id === 'cart-empty-shop-btn') closeCart();
  });

  getCart()
    .then(cart => {
      updateCartCount(cart);
      return renderCartItems(cart);
    })
    .catch(error => console.error('Initial cart load error:', error));
});
